export default "__VITE_ASSET__DovhUjuM__"